import React, { useMemo } from 'react';
import MessageContainer from '@/pages/datalab/pages/BehaviorAnalysis/GptAnalysis/Chat/components/MessageContainer';
import ChatInput from '@/pages/datalab/pages/BehaviorAnalysis/GptAnalysis/Chat/components/ChatInput';

import './index.scss';
import {useIntl} from '@@/plugin-locale/localeExports';


export default function Chat(props) {
  const {
    isError, // 是否出错
    onSend, // 发送按钮事件
    onStop, // 停止按钮事件
    minRows = 1,
    maxRows = 11,
    messages,
    isThinking,
    style,
    className = '',
		initialLoadingText
  } = props;
  const {formatMessage} = useIntl();
  const analysisInitialState = useMemo(() => {
    let loadingTypeConfig='';
			if (initialLoadingText){
      loadingTypeConfig	='dbl_gpt_message_analysis_thinking';
    } else {
      loadingTypeConfig	=	'dbl_gpt_message_thinking';
    }
    return loadingTypeConfig;
  }, [initialLoadingText]);
  return (
		<div className={`dbl-chat ${className}`} style={style}>
			<MessageContainer
        handleOnChangText={onSend}
				messages={messages}
				showThinking={isThinking && ['end', 'complete'].includes(messages?.[messages?.length-1]?.status)}
				thinkingContent={
					(<>{formatMessage({id:analysisInitialState})}<span>{formatMessage({id: 'dbl_gpt_message_thinking_info'})}</span></>)
				}
			/>
			<ChatInput
				showStop={isThinking}
				onSend={onSend}
				onStop={onStop}
				isError={isError}
			/>
		</div>
  );
}